import { api } from '@/v2/plugins/axios';

const API_PATH = '/v1/whatsapp/marketing/whatsapp-templates';
export class TemplatesEntity {
	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static fetchTemplates = async (queryParams) => {
		try {
			const { data: responseData } = await api.get(API_PATH, {
				params: queryParams,
			});
			const { result } = responseData;
			const { whatsapp_templates } = result;
			const { data: templates } = whatsapp_templates;

			return {
				data: templates.map((obj) => {
					return new TemplatesEntity(obj);
				}),
				totalRecords: whatsapp_templates?.total,
			};
		} catch (e) {
			console.log(e);
		}
	};

	static createTemplate = async (data) => {
		return api.post(API_PATH, data);
	};

	static isTemplateEditable = async (id) => {
		return api.get(`${API_PATH}/${id}/editable`);
	};

	async isEditable() {
		const res = await api.get(`${API_PATH}/${this.id}/editable`);
		return res?.data?.result?.is_editable;
	}

	static getTemplate = async (id) => {
		return api.get(`${API_PATH}/${id}`);
	};

	static updateTemplate = async (id, data) => {
		return api.patch(`${API_PATH}/${id}`, data);
	};

	hasFreeTextVariable() {
		const template = this.components || [];
		const body = template?.find((el) => el?.type === 'BODY');
		return body?.example?.body_text?.[0]?.includes('CONTEXT');
	}

    getTemplatePreview({ payload, image_url }) {
		const template = this.components || [];
		const header = template?.find((el) => el?.type === 'HEADER');
		const body = template?.find((el) => el?.type === 'BODY');
		const footer = template?.find((el) => el?.type === 'FOOTER');
		const buttons = template?.find((el) => el?.type === 'BUTTONS');

		return {
            template: this,
			header: {
				format: header?.format,
				text: header?.text,
				location: header?.location,
				image_url: image_url,
                document_url: payload?.[0]?.document_url,
                video_url: payload?.[0]?.video_url,
			},
			body: {
				text: body?.text,
				example: body?.example,
			},
			footer: {
				text: footer?.text,
			},
			buttons: {
				buttons: buttons?.buttons,
			},
			lto: {
				expiration_time_ms:
					payload?.[0]?.limited_time_offer?.parameters?.[0]?.expiration_time_ms,
				coupon_code: payload?.[0]?.buttons?.parameters?.[0]?.coupon_code,
				text: payload?.[0]?.body?.parameters?.[0]?.text,
			},
		};
	}
}

export default TemplatesEntity;
